import { c as _c } from "react/compiler-runtime";
import type { ItemLaminate } from "@sticker-giant/sg-frontend-common";
import { trackLaminationSelected } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionRadioField from "./OptionRadioField";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
import { useFieldErrorId } from "./ValidationError";
export default function Lamination() {
  const $ = _c(19);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedLaminate = usePdpStore(_temp);
  const selectedMaterial = usePdpStore(_temp2);
  const setLaminate = usePdpStore(_temp3);
  const clearValidationError = usePdpStore(_temp4);
  const laminateErrorId = useFieldErrorId("laminate");
  const laminationControlIdBase = `lamination-${product.sku}`;
  const laminationLabelId = `${laminationControlIdBase}-label`;
  const laminationHelpDialogId = `${laminationControlIdBase}-help-dialog`;
  const microcopyFields = useProductMicrocopy();
  const laminationHelper = microcopyFields?.laminationHelper;
  const laminationLabel = microcopyFields?.laminationLabel ?? "Lamination";
  const materialValue = selectedMaterial ?? productAdmin?.defaultMaterial;
  let t0;
  if ($[0] !== materialValue || $[1] !== productAdmin?.materialOptions) {
    t0 = productAdmin?.materialOptions.find(mat => mat.sku === materialValue);
    $[0] = materialValue;
    $[1] = productAdmin?.materialOptions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const materialOption = t0;
  let t1;
  if ($[3] !== materialOption?.laminateOptions || $[4] !== productAdmin?.laminateOptions) {
    t1 = materialOption?.laminateOptions ?? productAdmin?.laminateOptions ?? [];
    $[3] = materialOption?.laminateOptions;
    $[4] = productAdmin?.laminateOptions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const laminateOptions = t1;
  const laminateValue = selectedLaminate ?? productAdmin?.defaultLaminate;
  if (laminateOptions.length <= 1) {
    return null;
  }
  let t2;
  if ($[6] !== clearValidationError || $[7] !== setLaminate) {
    t2 = value => {
      const laminate = value as ItemLaminate;
      setLaminate(laminate);
      clearValidationError("laminate");
      trackLaminationSelected(laminate);
    };
    $[6] = clearValidationError;
    $[7] = setLaminate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== laminateErrorId || $[10] !== laminateOptions || $[11] !== laminateValue || $[12] !== laminationControlIdBase || $[13] !== laminationHelpDialogId || $[14] !== laminationHelper || $[15] !== laminationLabel || $[16] !== laminationLabelId || $[17] !== t2) {
    t3 = <OptionRadioField field="laminate" label={laminationLabel} helper={laminationHelper} controlIdBase={laminationControlIdBase} labelId={laminationLabelId} helpDialogId={laminationHelpDialogId} errorId={laminateErrorId} value={laminateValue} onValueChange={t2} options={laminateOptions} radioGroupClassName="flex gap-4" itemClassName="flex-1" />;
    $[9] = laminateErrorId;
    $[10] = laminateOptions;
    $[11] = laminateValue;
    $[12] = laminationControlIdBase;
    $[13] = laminationHelpDialogId;
    $[14] = laminationHelper;
    $[15] = laminationLabel;
    $[16] = laminationLabelId;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}
function _temp4(state_2) {
  return state_2.clearValidationError;
}
function _temp3(state_1) {
  return state_1.setLaminate;
}
function _temp2(state_0) {
  return state_0.material;
}
function _temp(state) {
  return state.laminate;
}